/** Normalize UUID strings for stable comparisons (trim + lowercase). */
export function normalizeUuid(value: string | undefined | null): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
}

/** True when both values are non-empty UUID strings and equal after normalization. */
export function uuidEquals(a: string | undefined | null, b: string | undefined | null): boolean {
  const x = normalizeUuid(a)
  const y = normalizeUuid(b)
  return x !== '' && y !== '' && x === y
}
